// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".worker .operation{font-size:.83333vw;display:flex;align-items:center}.worker .operation span{display:inline-block;margin-left:.52083vw}.worker img{margin:0 .78125vw;cursor:pointer;width:1.14583vw;height:1.14583vw}", ""]);
// Exports
module.exports = exports;
